module.exports = __webpack_public_path__ + "img/img1.9d9e2930.jpg";